<template>
    <div v-if="showReviews && reviews.length > 0" class="reviews-section mb-4">
        <div class="reviews-header">
            <h3 class="reviews-title mb-0">
                <i class="mdi mdi-star-circle text-warning mr-2"></i>
                {{ $t("sentence.sellerProductFeedback") }}
            </h3>
            <span class="reviews-count">{{ reviews.length }} {{ $t("avis") }}</span>
        </div>

        <div class="reviews-grid">
            <div v-for="rate in reviews" :key="rate.id" class="review-card">
                <div class="review-header">
                    <img v-if="rate.rater?.picture" :src="config.storageUrl + rate.rater?.picture" alt="Profile"
                        class="review-avatar" />
                    <div v-else class="review-avatar-placeholder">
                        {{ rate.rater?.username?.[0]?.toUpperCase() }}
                    </div>
                    <strong>{{ maskEmail(rate.rater.email) }}</strong>
                </div>
                <p class="review-text mb-0">{{ rate.message }}</p>
                <div class="review-footer">
                    <div class="review-rating">
                        <i class="mdi mdi-star text-warning"></i>
                        <span>{{ rate.rating || 'N/D' }}</span>
                    </div>
                    <span class="review-date">{{ rate.created_at | moment }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from "@/services/helper";
import config from "@/config";

export default {
    name: "ReviewsSection",
    props: {
        reviews: {
            type: Array,
            default: () => []
        },
        showReviews: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            config
        };
    },
    methods: {
        maskEmail: helper.maskEmail
    }
};
</script>

<style scoped>
/* Reviews Section */
.reviews-section {
    background: var(--gray-50);
    border-radius: 16px;
    padding: 2rem;
    border: 1px solid var(--gray-200);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.reviews-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid var(--gray-200);
    padding-bottom: 1rem;
    margin-bottom: 1.5rem;
}

.reviews-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--color-dark);
}

.reviews-count {
    background: var(--color-nz);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: 0 2px 8px rgba(38, 149, 255, 0.2);
}

.reviews-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1.25rem;
}

.review-card {
    background: white;
    border: 1px solid var(--gray-200);
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: 0.3s ease;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.review-card::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(135deg, var(--color-nz) 0%, var(--color-nz-200) 100%);
    transform: scaleY(0);
    transition: 0.3s ease;
}

.review-avatar,
.review-avatar-placeholder {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid var(--gray-200);
    flex-shrink: 0;
}

.review-avatar-placeholder {
    background: linear-gradient(135deg, var(--indigo) 0%, var(--purple) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 600;
    color: white;
}

.review-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.review-header strong {
    font-size: 0.95rem;
    color: var(--color-dark);
    font-weight: 600;
}

.review-text {
    color: var(--gray-600);
    font-size: 0.95rem;
    line-height: 1.5;
}

.review-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--gray-200);
    padding-top: 1rem;
    margin-top: auto;
}

.review-rating {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-weight: 600;
    color: var(--color-dark);
}

.review-date {
    font-size: 0.8rem;
    color: var(--gray-500);
}

@media (max-width: 768px) {
    .reviews-section {
        padding: 1.5rem;
    }

    .reviews-header {
        align-items: flex-start;
        gap: 1rem;
    }

    .reviews-grid {
        grid-template-columns: 1fr;
    }
}
</style>